import {
  CancleButton,
  CustomTable,
  LoaderBar,
  MoveWinnersButton,
  RankBadge,
  ScreenHeader,
  UserAvatarWithName,
} from 'components'
import React, { useMemo, useState } from 'react'
import { CommonUtility, CompetitionService } from 'utility'
import { useLocation, useNavigate, useParams } from 'react-router-dom'
import styled from 'styled-components'
import { Info } from 'phosphor-react'
import { notification } from 'antd'
import { GetSelectWinnerData } from 'hooks'
import { StyledCheckbox } from 'components/StyleCloseIcon'

const ButtonContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 16px;
  margin-top: 20px;
`
const InfoText = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  text-align: center;
  font-size: 12px;
  color: #4c4c4c;
  margin-top: 8px;
`
const HeaderWrapper = styled.div`
  display: flex;
  flex-direction: column;
  padding: 6px 45px;
  align-items: flex-start;
  width: 100%;
`

const TitleText = styled.p`
  font-family: Roboto;
  font-weight: 700;
  font-size: 14px;
  line-height: 100%;
  letter-spacing: 0%;
  color: #2454ff;
  margin-bottom: 0px;
  margin-top: 15px;
  margin-left: 10px;
`

const HeaderContent = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;
`
const SelectWinnersContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  margin-top: 30px;
  width: 100%;
`

// const SelectWinnersText = styled.span`
//   font-family: Roboto;
//   font-size: 16px;
//   font-weight: 600;
//   color: #000;
//   margin-left: 10px;
// `

const SelectButton = styled.button`
  font-family: 'Roboto';
  // background: linear-gradient(135deg, #38ef7d, #11998e);
  // background: linear-gradient(135deg, #ffd700, #ffae42);
  background: linear-gradient(135deg, #ff7e5f, #feb47b);
  color: white;
  border: none;
  padding: 6px 24px;
  font-size: 16px;
  font-weight: 600;
  border-radius: 4px;
  cursor: pointer;
  text-align: center;
  transition: all 0.3s ease-in-out;
  box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.1);

  &:hover {
    transform: translateY(-1px);
  }
`
export const WinnerSelectionPage = () => {
  const { competitionId, round } = useParams()
  const navigate = useNavigate()
  const { data,competition, filter, pageChanged, total, loading, updateFilters, winners } =
    GetSelectWinnerData(competitionId, round)
  const location = useLocation();
  const { competitionName } = location.state || {};
  const [selected, setSelected] = useState([])
  const [loading1, setLoading1] = useState(false)
  const handleCheckboxChange = record => {
    if (Number(winners) === Number((selected?.length ?? 0))) {
      if (selected?.includes(record?.fid) || selected?.length === 0) {
        setSelected(prev =>
          prev.includes(record?.fid)
            ? prev.filter(id => id !== record?.fid)
            : [...prev, record?.fid],
        )
        return
      }
      notification.warning({
        message: 'Warning!',
        description: `You can move only ${winners} Winners`,
      })
      return
    }
    setSelected(prev =>
      prev.includes(record?.fid)
        ? prev.filter(id => id !== record?.fid)
        : [...prev, record?.fid],
    )
  }

  const handleMoveWinners = async () => {
    try {
      setLoading1(true)
      if (selected?.length === 0) {
        notification.warning({
          message: 'Warning!',
          description: 'Winner selection is required.',
        })
        return
      }

      const data = {
        winnerIds: selected,
      }
      await CompetitionService.moveWinner(competitionId, round, data)
      setLoading1(false)
      notification.success({
        message: 'Success!',
        description: 'Winners Move SuccessFully',
      })
      navigate(`/app/competitions/${competitionId}`)
    } catch (error) {
      notification.error({
        description: error?.response?.data?.message?.toString(),
        message: 'Something Went Wrong',
      })
    } finally {
      setLoading1(false)
    }
  }
  const columns = useMemo(
    () => [
      {
        title: 'Flag',
        dataIndex: 'flag',
        key: 'flag',
        width: 35,
        render: (_, record) => (
          <StyledCheckbox
            onChange={() => handleCheckboxChange(record)}
            checked={selected?.includes(record?.fid)}
          />
        ),
      },
      {
        title: '#Rank',
        dataIndex: 'rank',
        key: 'rank',
        render: value => <RankBadge rank={value} />,
      },
      {
        title: 'Creator Name',
        dataIndex: 'creator_name',
        key: 'creator',
        render: (_, record) => (
          <UserAvatarWithName id={record?.fid} title={record?.name} url={record.image} />
        ),
      },
      {
        title: 'Video',
        dataIndex: 'video',
        key: 'video',
        render: (_, record) => (
          <div style={{ display: 'flex', alignItems: 'center' }}>
            <img
              src={record?.thumbnail_url}
              alt="video thumbnail"
              style={{
                width: '30px',
                height: '30px',
                borderRadius: '2px',
                objectFit: 'cover',
              }}
            />
            <span style={{ marginLeft: '8px' }}>{record?.title}</span>
          </div>
        ),
      },
      {
        title: 'Votes',
        dataIndex: 'total_votes',
        key: 'total_votes',
        render: value => <span>{CommonUtility.numberFormat(value)}</span>,
      },
      {
        title: 'Views',
        dataIndex: 'total_views',
        key: 'total_views',
        render: value => <span>{CommonUtility.numberFormat(value)}</span>,
      },

      {
        title: 'Comments',
        dataIndex: 'total_comments',
        key: 'total_comments',
        render: value => <span>{CommonUtility.numberFormat(value)}</span>,
      },
    ],
    [navigate, selected],
  )

  const updateSelection = (flag) => {
    const selected = flag ? data.slice(0, winners).map(item => item.fid) : [];
    setSelected(selected);
  };
  return (
    <div>
      <HeaderWrapper>
        <TitleText>{competition || competitionName} - Round {round}</TitleText>
        <HeaderContent>
          <ScreenHeader text="Select Winners" />
          <Info size={22} color="#4c4c4c" />
        </HeaderContent>
        <SelectWinnersContainer>
          {/* <SelectWinnersText>Select Winners:</SelectWinnersText> */}

          {/* <SelectButton onClick={() => updateFilters('type', 'winner')}>
            {winners}
          </SelectButton> */}
          <SelectButton onClick={() => updateFilters('type', 'winner')}>
            Pick {winners} Winners
          </SelectButton>

          {/* <SelectButton onClick={() => updateFilters("sort", 'top200')}>Top 200</SelectButton>
            <SelectButton onClick={() => updateFilters("sort", 'top100')}>Top 100</SelectButton>
            <SelectButton onClick={() => updateFilters("sort", 'top10')}>Top 10</SelectButton> */}
        </SelectWinnersContainer>
      </HeaderWrapper>
      {loading ? (
        <LoaderBar />
      ) : (
        <div className="px-5">
          <CustomTable
            data={data}
            columns={columns}
            pageChanged={pageChanged}
            page={filter?.page}
            pageSize={10}
            selected={selected}
            updateFilter={updateFilters}
            onAllSelect={updateSelection}
            loading={loading}
            rankings
            hideIndex
            total={total}
          />
        </div>
      )}

      <ButtonContainer>
        <CancleButton onClick={() => navigate(-1)}>Cancel</CancleButton>
        <MoveWinnersButton disabled={loading1} onClick={handleMoveWinners}>
          Move winners
        </MoveWinnersButton>
      </ButtonContainer>

      <InfoText>
        <Info size={15} color="#4c4c4c" />
        Selected creators will move to next round after you move them.
      </InfoText>
    </div>
  )
}
